import React, { useCallback } from "react";
import { Flex, Button } from "@radix-ui/themes";
import { FormSingleSelectMessage } from "../../entities/Message";

interface FormSingleSelectMessageComponentProps
  extends FormSingleSelectMessage {
  isLastMessage: boolean;
  sendFormOptionSelected: (formId: string, option: string) => Promise<void>;
}

export function FormSingleSelectMessageComponent({
  isLastMessage,
  data: { options, formId },
  sendFormOptionSelected,
}: FormSingleSelectMessageComponentProps) {
  const handleSelectOption = useCallback(
    async (option: string) => {
      if (!isLastMessage) {
        return;
      }

      return sendFormOptionSelected(formId, option);
    },
    [sendFormOptionSelected, formId, isLastMessage]
  );

  return (
    <Flex
      gap={"8px"}
      wrap={"wrap"}
      style={{
        paddingLeft: "36px",
      }}
    >
      {options.map((option, index) => (
        <Button
          key={`${formId}-${index}`}
          disabled={!isLastMessage}
          variant="outline"
          color="gray"
          style={{
            borderRadius: "var(--1, 4px)",
            border: "1px solid var(--Info-info-bg-subtle, #EDF6FF)",
            background: "var(--Info-info-bg-subtle, #EDF6FF)",
            color: "var(--Text-text-primary, rgba(0, 5, 9, 0.89))",
            textAlign: "center",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24px",
            boxShadow: "none",
            width: "fit-content",
            cursor: !isLastMessage ? "not-allowed" : "pointer",
          }}
          onClick={() => handleSelectOption(option)}
          aria-label={`Select option ${option}`}
        >
          {option}
        </Button>
      ))}
    </Flex>
  );
}
